// this file added by Bearer Web Developer

export const log = (...args : any[]) => {
    if (process.env.NODE_ENV === "development") console.log(...args);
}
export const error = (...args : any[]) => {
    if (process.env.NODE_ENV === "development") console.error(...args);
}